import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/styles'
import { Page, Header } from 'components'
import { useAuth } from 'hooks/useAuth'
import useRouter from 'utils/useRouter'
import constants from 'utils/constants'

import { Results } from './components'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  alert: {
    marginBottom: 0,
  },
}))

export const DadoGerenciavel = (props) => {
  const { route } = props
  const classes = useStyles()
  const gerenciamentoBalisticoState = useSelector((state) => state.gerenciamentoBalistico)
  const itensBalisticos = useSelector((state) => state.gerenciamentoBalistico.itensBalisticos)
  const carregando = useSelector((state) => state.gerenciamentoBalistico.processando)
  const router = useRouter()
  const { permissoesUsuario, verificarPermissao } = useAuth()

  useEffect(() => {

    if (permissoesUsuario?.length) {
      if(!verificarPermissao([constants.PERMISSOES.ADMINISTRAR_SISTEMA])) {
        router.history.push(`/`)
      }
    }
  }, [permissoesUsuario])

  return (
    <Page className={classes.root} title={`${route.secao} - SIGEP`}>
      <Header title={`${route.secao}`} overline={route.secao} />

      <Results
        className={classes.results}
        carregando={carregando}
        modeloBalistico={gerenciamentoBalisticoState.modelo_balistico}
        dados={itensBalisticos}
      />
    </Page>
  )
}
